<template>
  <div class="home-page">
    <div class="main-box">
      <div class="img-wrapper">
        <img class="topImg" src="https://admin.syljhky.com///uploads/20260424/9f22a5a6f49039b563e4f6ac0f61f48d.png"></img>
        <img class="bottomImg" src="https://admin.syljhky.com///uploads/20260422/deb8276f0e4b1079198654f864de024b.png"></img>
      </div>
      <div class="main-content">
        <div class="top">
          <div class="title">集团简介</div>
          <div class="more" @click="toDetail('/aboutUs', 5)">
            <div class="text">Learn more</div>
            <div class="arrow-right"></div>
          </div>
        </div>
        <div class="EngText">Group Profile</div>
        <div class="profile-content">
          <img class="groupImg" :src="groupImg"></img>
          <div class="right">
            <div class="groupContent" v-html="groupContent"></div>
            <div @click="toAboutUs()" class="btn-box">
              <div class="text">查看详情</div>
              <div class="arrow-right"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 0 42px;">
      <div class="business-content">
        <div class="content">
          <div class="top">
            <div class="title">集团业务</div>
            <div class="more" @click="toDetail('/groupBusiness', 2)">
              <div class="text">Learn more</div>
              <div class="arrow-right"></div>
            </div>
          </div>
          <div class="EngText">Group Business</div>
          <div class="group-list">
            <div class="item" @click="toGroupDetail(item)" v-for="(item, i) in groupList" :key="i">
              <img :src="item.firstimage" alt="">
              <div class="title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 0 42px;">
      <div class="news-content">
        <div class="content">
          <div class="top">
            <div class="title">集团新闻</div>
            <div class="more" @click="toDetail('/groupNews', 3)">
              <div class="text">Learn more</div>
              <div class="arrow-right"></div>
            </div>
          </div>
          <div class="EngText">Group News</div>
          <div class="news-box">
            <div class="time">{{ newsList[0] ? newsList[0].time : '' }}</div>
            <div class="title">{{ newsList[0] ? newsList[0].title : '' }}</div>
            <div class="detail-btn" @click="toNewsDetail(newsList)">
              <span class="arrow"></span>
              <span class="text">查看详情</span>
            </div>
          </div>
          <div class="news-list">
            <div class="news-item" @click="toNewsDetail(item)" v-for="(item, index) in newsList.slice(1)" :key="index"
              :style="{ '--bg': `url(${item.image})` }">
              <div class="time">{{ item.time }}</div>
              <div class="title">{{ item.title }}</div>
              <div class="desc" v-html="item.content"></div>
              <div class="detail-btn">
                <span class="arrow"></span>
                <span class="text">查看详情</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 0 42px;">
      <div class="future-banner">
        <div class="banner-wrap">
          <div class="text1">以企业价值动力社会进步</div>
          <div class="text2">以广阔胸襟开启梦想未来</div>
          <div class="link-btn" @click="toAboutUs()">了解更多</div>
        </div>
      </div>
    </div>
    <div style="padding: 0 42px;">
      <div class="expert-section">
        <div class="content">
          <div class="top">
            <div class="title">专家团队</div>
            <div class="more" @click="toDetail('/expertTeam', 4)">
              <div class="text">Learn more</div>
              <div class="arrow-right"></div>
            </div>
          </div>
          <div class="EngText">Expert Team</div>
          <div class="desc">
            构建“核心管理+医疗技术+一线护理+专业运营”的多层级人才体系。60余名核心管理成员，由40%康养机构领军人物、40%部队医院/疗养院医学管理骨干、20%资深运营高手构成，平均拥有10年以上相关经验；
          </div>

          <div class="expert-carousel">
            <div class="expert-group">
              <div class="expert-item" v-for="(item, i) in doctorList" :key="i">
                <img :src="item.image" alt="" />
              </div>

              <div class="expert-item" v-for="(item, i) in doctorList" :key="`copy-${i}`">
                <img :src="item.image" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="company-box">
      <div class="content">
        <div class="top">
          <div class="title">合作伙伴</div>
          <div class="more" @click="toAboutUs()">
            <div class="text">Learn more</div>
            <div class="arrow-right"></div>
          </div>
        </div>
        <div class="EngText">Partners</div>

        <div class="company-list">
          <div class="company-item" v-for="(item, index) in companyList" :key="index">
            <img :src="item.image" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomeView",
  data() {
    return {
      groupList: [],
      newsList: [],
      doctorList: [],
      companyList: [],
      groupImg: '',
      groupContent: '',
      aboutObj: '',
    };
  },
  methods: {
    toNewsDetail(item) {
      if (Array.isArray(item)) {
        item = { id: item[0].id }
      }
      this.$router.push({
        path: '/newsDetail',
        query: {
          ids: item.id,
          id: 3
        }
      })
    },
    toGroupDetail(item) {
      this.$router.push({
        path: '/groupDetail',
        query: {
          ids: item.id,
          id: 2
        }
      })
    },
    toDetail(path, id) {
      this.$router.push({
        path: path,
        query: {
          id: id,
        }
      })
    },
    toAboutUs() {
      this.$router.push({
        path: '/aboutUs',
        query: {
          id: 5,
        }
      })
    },
    getCompanyList() {
      this.axios.post("/api/index/getCompanyList")
        .then(res => {
          this.companyList = res.slice(0, 6)
          this.companyList.forEach(item => {
            item.image = "https://admin.syljhky.com//" + item.image;
          })
        })
    },
    getDoctorList() {
      this.axios.post("/api/index/getDoctorList")
        .then(res => {
          this.doctorList = res
          this.doctorList.forEach(item => {
            item.image = "https://admin.syljhky.com//" + item.image;
          })
        })
    },
    getNewsList() {
      this.axios
        .post("/api/index/getNewsList", { p: '4' })
        .then((res) => {
          this.newsList = res.list
          this.newsList.forEach((item) => {
            item.image = "https://admin.syljhky.com//" + item.image;
          });

        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGroupList() {
      this.axios
        .post("/api/index/getGroupList")
        .then((res) => {
          this.groupList = res.slice(0, 3)
          this.groupList.forEach((item) => {
            item.firstimage = "https://admin.syljhky.com//" + item.firstimage;
          });

        })
        .catch((err) => {
          console.log(err);
        });
    },
    getGroup() {
      this.axios
        .post("/api/index/getGroup")
        .then((res) => {
          this.groupImg = "https://admin.syljhky.com//" + res.images
          this.groupContent = res.content
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getGroup();
    this.getGroupList();
    this.getNewsList();
    this.getDoctorList();
    this.getCompanyList();
  },
};
</script>
<style lang="scss">
body {
  padding: 0 !important;
  margin: 0 !important;
  box-sizing: border-box;
}

.home-page {
  width: 100%;
  box-sizing: border-box;  
  background-color: #fff;

  .company-box {
    background: #E5E5E5;
    width: 100%;
    padding: 20px 0;

    .content {
      width: 50%;
      margin: 0 auto;
      text-align: left;

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 4px solid #b1b1b1;
        padding-bottom: 6px;

        .title {
          font-size: 24px;
          color: #15447C;
        }

        .more {
          display: flex;
          align-items: center;
          cursor: pointer;

          .text {
            font-size: 18px;
            color: #b1b1b1;
            margin-right: 4px;
          }

          .arrow-right {
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid #b1b1b1;
          }
        }
      }

      .EngText {
        font-size: 18px;
        color: #b1b1b1;
        margin-top: 6px;
        margin-bottom: 54px;
        }

      .company-list {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        width: 106%;
        margin-left: -3%;
        margin-right: -3%;
        .company-item {
          width: 200px;
        }
      }

    }
  }

  .expert-section {
    position: relative;
    z-index: 10;
    width: 100%;
    background: url("https://admin.syljhky.com///uploads/20260422/2ad0bd49ef8958dc0ab3f254e4ba1c64.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 54px 0;
    box-sizing: border-box;

    .content {
      width: 52%;
      margin: 0 auto;
      text-align: left;

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 4px solid #e5e5e5;
        padding-bottom: 6px;

        .title {
          font-size: 24px;
          color: #15447C;
        }

        .more {
          display: flex;
          align-items: center;
          cursor: pointer;

          .text {
            font-size: 18px;
            color: #DBD8D8;
            margin-right: 4px;
          }

          .arrow-right {
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid #DBD8D8;
          }
        }
      }

      .EngText {
        font-size: 18px;
        color: #DBD8D8;
        margin-top: 6px;
        margin-bottom: 54px;
      }


      .desc {
        width: 80%;
        font-size: 14px;
        color: #999;
        line-height: 1.6;
        text-align: center;
        margin: 40px auto;
      }

      .expert-carousel {
        width: 100%;
        margin-top: 30px;
        overflow: hidden;
        cursor: pointer;
      }

      .expert-group {
        display: flex;
        width: max-content;
        gap: 20px;
        animation: expertScroll 25s linear infinite;
      }

      /* 悬浮暂停滚动 */
      .expert-group:hover {
        animation-play-state: paused;
      }

      .expert-item {
        width: 230px;
        height: 300px;
        border-radius: 14px;
        overflow: hidden;
        flex-shrink: 0;
      }

      .expert-item img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      /* 关键动画：一直向右，无缝循环 */
      @keyframes expertScroll {
        0% {
          transform: translateX(0);
        }

        100% {
          transform: translateX(-50%);
        }
      }

    }
  }

  .future-banner {
    width: 100%;
    box-sizing: border-box;
    background: url("https://admin.syljhky.com//uploads/20260422/71782fabab249d200c92c02240c92d6d.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    .banner-wrap {
      padding: 100px 20px;
      text-align: center;
      color: #fff;

      .text1 {
        font-size: 26px;
        margin-bottom: 10px;
      }

      .text2 {
        font-size: 40px;
        font-weight: bold;
        margin-bottom: 35px;
      }

      .link-btn {
        display: inline-block;
        font-size: 18px;
        padding-bottom: 6px;
        border-bottom: 2px solid #fff;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          opacity: 0.7;
          border-bottom-color: #ccc;
        }
      }
    }
  }

  .news-content {
    background: linear-gradient(180deg, #FFF 0%, #eee 100%);
    z-index: 10;
    width: 100%;
    padding: 20px 0;

    .content {
      margin: 0 auto;
      width: 52%;
      height: 100%;
      text-align: left;

      .news-list {
        display: flex;
        gap: 20px;
        flex-wrap: nowrap;
        width: 106%;
        margin-left: -3%;
        margin-right: -3%;

        .news-item {
          flex: 1;
          min-width: 0;
          padding: 28px;
          background: #fff;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;

          &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-image: var(--bg);
            background-size: cover;
            background-position: center;
            opacity: 0;
            transition: opacity 0.3s ease;
            z-index: 0;
          }

          >* {
            position: relative;
            z-index: 1;
          }

          &:hover {
            &::before {
              opacity: 1;
            }

            .arrow {
              border-left-color: #fff;
            }
          }

          .time {
            font-size: 18px;
            color: #b1b1b1;
            margin-bottom: 12px;
          }

          .title {
            font-size: 19px;
            color: #5F5F5F;
            font-weight: 500;
            margin-bottom: 10px;
            line-height: 1.4;
          }

          .desc {
            font-size: 13px;
            color: #5F5F5F;
            line-height: 1.5;
            margin-bottom: 18px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .detail-btn {
            display: inline-flex;
            align-items: center;
            font-size: 24px;
            color: #15447C;

            .arrow {
              width: 0;
              height: 0;
              border-top: 5px solid transparent;
              border-bottom: 5px solid transparent;
              border-left: 8px solid #15447C;
              margin-right: 6px;
              transition: all 0.3s ease;
            }
          }
        }
      }

      .news-box {
        .time {
          font-size: 18px;
          color: #B1B1B1;
          margin-bottom: 38px;
        }

        .title {
          font-size: 38px;
          color: #B1B1B1;
          font-weight: bold;
          margin-bottom: 52px;
        }

        .detail-btn {
          display: inline-flex;
          align-items: center;
          color: #15447C;
          font-size: 24px;
          font-weight: 500;
          cursor: pointer;
          margin-bottom: 48px;

          .arrow {
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid #15447C;
            margin-right: 10px;
          }
        }
      }

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 4px solid #e5e5e5;
        padding-bottom: 6px;

        .title {
          font-size: 24px;
          color: #15447C;
        }

        .more {
          display: flex;
          align-items: center;
          cursor: pointer;

          .text {
            font-size: 18px;
            color: #DBD8D8;
            margin-right: 4px;
          }

          .arrow-right {
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid #DBD8D8;
          }
        }
      }

      .EngText {
        font-size: 18px;
        color: #DBD8D8;
        margin-top: 6px;
        margin-bottom: 54px;
      }
    }
  }

  .main-box {
    width: 100%;
    position: relative;

    .img-wrapper {
      position: relative;
      z-index: 1;

      .topImg {
        width: 100%;
        padding: 0 42px;
        transform: translateY(-180px);
      }

      .bottomImg {
        display: block;
        margin-top: -12%;
        width: 100%;
      }
    }

    .main-content {
      width: 58%;
      position: absolute;
      top: 15%;
      left: 50%;
      transform: translateX(-50%);
      background-color: #fff;
      border-radius: 21px;
      z-index: 10;
      padding: 70px 100px;
      text-align: left;
      box-sizing: border-box;

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 4px solid #e5e5e5;
        padding-bottom: 6px;

        .title {
          font-size: 24px;
          color: #15447C;
        }

        .more {
          display: flex;
          align-items: center;
          cursor: pointer;

          .text {
            font-size: 18px;
            color: #DBD8D8;
            margin-right: 4px;
          }

          .arrow-right {
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid #DBD8D8;
          }
        }
      }

      .EngText {
        font-size: 18px;
        color: #DBD8D8;
        margin-top: 6px;
        margin-bottom: 54px;
      }

      .profile-content {
        display: flex;
        align-items: center;
        gap: 30px;

        .groupImg {
          width: 50%;
        }

        .right {
          width: 46%;

          .groupContent {
            margin-bottom: 10px;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .btn-box {
            display: flex;
            align-items: center;
            background-color: #2266B8;
            padding: 4px 6px;
            border-radius: 5px;
            width: fit-content;
            cursor: pointer;

            .text {
              font-size: 17px;
              color: #fff;
              margin-right: 6px;
            }

            .arrow-right {
              width: 0;
              height: 0;
              border-top: 4px solid transparent;
              border-bottom: 4px solid transparent;
              border-left: 8px solid #fff;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .main-box {
      .img-wrapper {
        display: none !important;
      }

      .main-content {
        position: relative !important;
        top: auto !important;
        left: auto !important;
        transform: none !important;
        width: 92% !important;
        margin: 30px auto 0 !important;
        padding: 25px 20px !important;
        border-radius: 16px !important;
      }

      .profile-content {
        flex-direction: column !important;
      }

      .groupImg,
      .right {
        width: 100% !important;
      }
    }
  }

  .business-content {
    position: relative;
    z-index: 10;
    width: 100%;
    background: url("https://admin.syljhky.com///uploads/20260422/2ad0bd49ef8958dc0ab3f254e4ba1c64.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 54px 0;
    box-sizing: border-box;

    .content {
      width: 52%;
      margin: 0 auto;
      text-align: left;

      .group-list {
        display: flex;
        justify-content: space-around;
        align-items: center;
        gap: 20px;
        flex-wrap: nowrap;
        width: 95%;
        max-width: 1500px;
        margin: 0 auto;

        .item:hover {
          transform: scale(1.06);
          z-index: 99;
        }

        .item:hover .title {
          color: #fff;
          font-size: 26px;
          bottom: 60px;
        }

        .item {
          flex: 0 1 32%;
          aspect-ratio: 3 / 4;
          border-radius: 12px;
          overflow: hidden;
          position: relative;
          cursor: pointer;
          transition: all 0.3s ease;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
            display: block;
            border-radius: 20px;
            transition: transform 0.3s ease;
          }

          .title {
            position: absolute;
            bottom: 50px;
            left: 50%;
            transform: translateX(-50%);
            color: #8DD3FF;
            font-size: 24px;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.3s ease;

            &::after {
              content: '';
              display: block;
              height: 3px;
              background-color: #8DD3FF;
              margin: 8px auto 0;
              transition: all 0.3s ease;
            }
          }
        }
      }

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 4px solid #e5e5e5;
        padding-bottom: 6px;

        .title {
          font-size: 24px;
          color: #15447C;
        }

        .more {
          display: flex;
          align-items: center;
          cursor: pointer;

          .text {
            font-size: 18px;
            color: #DBD8D8;
            margin-right: 4px;
          }

          .arrow-right {
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-left: 12px solid #DBD8D8;
          }
        }
      }

      .EngText {
        font-size: 18px;
        color: #DBD8D8;
        margin-top: 6px;
        margin-bottom: 54px;
      }
    }

    @media (max-width: 768px) {
      padding: 30px 0;

      .content {
        width: 90%;

        .top .title {
          font-size: 20px;
        }

        .EngText {
          margin-bottom: 30px;
        }

        .group-list {
          flex-direction: column;
          gap: 15px;

          .item {
            flex: none;
            width: 100%;
            aspect-ratio: 16 / 9; // 手机端改成横版卡片，更舒服
          }
        }
      }
    }
  }

  /* 平板 */
  @media (max-width: 1200px) {
    .main-box .main-content {
      padding: 20px 40px;

      .EngText {
        margin-bottom: 10px;
      }
    }
  }

  /* 小平板 */
  @media (max-width: 992px) {
    .main-box .main-content {
      top: 5%;
      width: 70%;
    }
  }
}
</style>
